import React from 'react';
import { TrendingUp, Calendar, Award, Sparkles } from 'lucide-react';


const RevenueSection = ({ content }) => {
  if (!content) return null;
  const revenueModel = content;

  return (
    <section id="revenue" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {revenueModel.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-amber-500 mx-auto rounded-full" />
        </div>

        {/* Pricing Grid */}
        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          {/* Villa Pricing */}
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 text-white shadow-xl">
            <div className="flex items-center gap-3 mb-6">
              <Award className="w-8 h-8" />
              <h3 className="text-2xl font-bold">The Luxury Villa</h3>
            </div>
            <div className="space-y-4">
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span className="text-blue-100">Low Season</span>
                <span className="text-2xl font-bold">
                  {revenueModel.pricing.villa.lowSeason}
                </span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span className="text-blue-100">Mid Season</span>
                <span className="text-2xl font-bold">
                  {revenueModel.pricing.villa.midSeason}
                </span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span className="text-blue-100">High Season</span>
                <span className="text-2xl font-bold">
                  {revenueModel.pricing.villa.highSeason}
                </span>
              </div>
            </div>
          </div>

          {/* Farmhouse Pricing */}
          <div className="bg-gradient-to-br from-amber-600 to-amber-700 rounded-2xl p-8 text-white shadow-xl">
            <div className="flex items-center gap-3 mb-6">
              <Sparkles className="w-8 h-8" />
              <h3 className="text-2xl font-bold">The Authentic Farm House</h3>
            </div>
            <div className="space-y-4">
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span className="text-amber-100">Low Season</span>
                <span className="text-2xl font-bold">
                  {revenueModel.pricing.farmhouse.lowSeason}
                </span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span className="text-amber-100">Mid Season</span>
                <span className="text-2xl font-bold">
                  {revenueModel.pricing.farmhouse.midSeason}
                </span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span className="text-amber-100">High Season</span>
                <span className="text-2xl font-bold">
                  {revenueModel.pricing.farmhouse.highSeason}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Occupancy and Experience */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Occupancy */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200">
            <div className="flex items-center gap-3 mb-6">
              <Calendar className="w-8 h-8 text-green-600" />
              <h3 className="text-2xl font-bold text-slate-900">
                {revenueModel.occupancy.title}
              </h3>
            </div>
            <div className="text-center py-8">
              <div className="text-6xl font-bold text-green-600 mb-2">
                {revenueModel.occupancy.rate}
              </div>
              <p className="text-slate-600">
                {revenueModel.occupancy.description}
              </p>
            </div>
          </div>

          {/* Guest Experience */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200">
            <div className="flex items-center gap-3 mb-6">
              <TrendingUp className="w-8 h-8 text-blue-600" />
              <h3 className="text-2xl font-bold text-slate-900">
                {revenueModel.experience.title}
              </h3>
            </div>
            <p className="text-lg text-slate-700 mb-6">
              {revenueModel.experience.brand}
            </p>
            <ul className="space-y-3">
              {revenueModel.experience.services.map((service, index) => (
                <li
                  key={index}
                  className="flex items-center gap-3 text-slate-700"
                >
                  <span className="w-2 h-2 bg-blue-600 rounded-full" />
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RevenueSection;
